import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
  inject,
  PLATFORM_ID,
  provideAppInitializer
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { clientIdInterceptor } from './core/interceptors/client-id.interceptor';
import { accessTokenInterceptor } from './core/interceptors/access-token.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { AvailableLangs, provideTransloco, TranslocoService } from '@jsverse/transloco';
import { isPlatformBrowser } from '@angular/common';

function initTranslocoLang() {
  const transloco = inject(TranslocoService);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  const available = (transloco.getAvailableLangs() as AvailableLangs)
    .map(l => typeof l === 'string' ? l : l.id);

  const browserLangs = isBrowser
    ? (globalThis.navigator?.languages ?? [globalThis.navigator?.language].filter(Boolean) as string[])
    : [];

  const match = browserLangs
    .map(code => code?.split?.('-')[0]?.toLowerCase())
    .find(lang => !!lang && available.includes(lang!));

  transloco.setActiveLang(match ?? transloco.getDefaultLang());
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideHttpClient(withInterceptors([httpErrorInterceptor, clientIdInterceptor, accessTokenInterceptor])), provideAnimationsAsync(), provideHttpClient(), provideTransloco({
    config: {
      availableLangs: ['de', 'fr', 'it', 'en'],
      defaultLang: 'en',
      fallbackLang: 'en',
      reRenderOnLangChange: false,
      prodMode: !isDevMode()
    },
    loader: TranslocoHttpLoader
  }),
    provideAppInitializer(() => initTranslocoLang()),
  ]
};
